import React, { useState } from "react";
import CustomHeaderTitleView from "presentational/common/CustomHeaderTitleView";
import ImageCropperPanel from "container/upload/ImageCropperPanel";
import ItemInfoAdderPanel from "container/upload/ItemInfoAdderPanel";
import ItemSummaryPanel from "container/upload/ItemSummaryPanel";
import TXT from "presentational/common/multinational/TXT";
import { useHistory } from "react-router-dom";
import config from "lib/fr-config";
import PropTypes from "prop-types";

const IMAGE_QUALITY = config.uploadImageQuality.item;

RootItemUpload.propTypes = {
  onExitClick: PropTypes.func,
  alreadyLoadedImageData: PropTypes.object
};

RootItemUpload.defaultProps = {
  onExitClick: null,
  alreadyLoadedImageData: null
};

function RootItemUpload(props) {
  const { alreadyLoadedImageData, onExitClick } = props;
  const [croppedImageDataURL, setCroppedImageDataURL] = useState(null);
  const [internalCropData, setInternalCropData] = useState(null);
  const [itemInfo, setItemInfo] = useState({
    category: "",
    brand: "",
    color: "",
    tag: ""
  });
  const [phase, setPhase] = useState("imageCrop");
  const [
    hasAddImageButtonClickedAtLeastOnce,
    setHasAddImageButtonClickedAtLeastOnce
  ] = useState(false);

  const history = useHistory();

  const goBack = () => {
    if (!onExitClick) history.goBack();
    else onExitClick();
  };

  const goToImageCropPhase = () => {
    setPhase("imageCrop");
  };

  const goToInfoAddPhase = () => {
    setPhase("infoAdd");
  };

  const goToSummaryPhase = () => {
    setPhase("summary");
  };

  const handleImageCrop = (croppedImageDataURL, internalCropData) => {
    setCroppedImageDataURL(croppedImageDataURL);
    setInternalCropData(internalCropData);
  };

  const handleInfoChange = (type, value) => {
    const result = value || "";
    setItemInfo({ ...itemInfo, [type]: result });
  };

  const handleUploadComplete = () => {
    goBack();
  };

  const handleAddImageBtnClick = () => {
    setHasAddImageButtonClickedAtLeastOnce(true);
  };

  return (
    <div>
      <CustomHeaderTitleView
        title={<TXT name="titleImgUpload_item" />}
        displayOnMobile
        displayOnDesktop
      />
      {phase === "imageCrop" && (
        <ImageCropperPanel
          imageType="item"
          alreadyLoadedImageData={alreadyLoadedImageData}
          internalCropData={internalCropData}
          resultImageQuality={IMAGE_QUALITY}
          onImageCrop={handleImageCrop}
          onCancelClick={goBack}
          onNextClick={goToInfoAddPhase}
          hasAddImageButtonClickedAtLeastOnce={
            hasAddImageButtonClickedAtLeastOnce
          }
          onAddImageBtnClick={handleAddImageBtnClick}
        />
      )}
      {phase === "infoAdd" && (
        <ItemInfoAdderPanel
          imageDataURL={croppedImageDataURL}
          onInfoChange={handleInfoChange}
          onBackClick={goToImageCropPhase}
          onNextClick={goToSummaryPhase}
          itemInfo={itemInfo}
        />
      )}
      {phase === "summary" && (
        <ItemSummaryPanel
          imageDataURL={croppedImageDataURL}
          itemInfo={itemInfo}
          onBackClick={goToInfoAddPhase}
          onUploadComplete={handleUploadComplete}
        />
      )}
    </div>
  );
}

export default RootItemUpload;
